<template>
    <div class="container">
        <div class="head_bg">
            <common-head></common-head>
            <div class="head_content">
                <img src="../assets/images/img_john.png" alt="">
                <div class="head_content_text">
                    <div>“</div>
                    <van-swipe :autoplay="5000" :show-indicators="false" :touchable="false">
                        <van-swipe-item>
                            <p>
                                我们提倡的价值观是：谦（满招损谦受益）、诚(不信不立 不诚不行）、善（上善若水 泽被万物）、思（用心创造）
                            </p>
                        </van-swipe-item>
                        <van-swipe-item>
                            <p>我们的使命是：Do my best，Make it easy</p>
                        </van-swipe-item>
                        <van-swipe-item>
                            <p>我们的愿景：Change myself, Change the world（Even a little）</p>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
        </div>

        <div class="bg_c_w ">
            <div class="introduce">
                <h1>公司介绍</h1>
                <p>
                    杭州多麦电子商务股份有限公司，成立于2010年8月，互联网精准营销的领军企业。
                </p>
                <p>
                    我们为全球知名品牌提供一站式营销解决方案，包括品牌传播、互动传播、内容传播及ROI战略合作等；目前服务全球800+知名电商平台、服饰、奢侈品、快销品、数码、金融、教育、泛娱乐等各领域知名品牌。
                </p>
                <p>
                    我们通过自主研发的精准营销技术、大数据技术，实现基于广告预算、地域和目标用户画像的新媒体程序化广告投放，为微软、京东等全球新零售领域的上千家标杆企业或平台提供互联网新媒体效果营销服务。
                </p>
                <img src="../assets/images/jieshao_img.png" alt="">
            </div>
            <div class="honor">
                <h1>公司荣誉</h1>
                <van-swipe :autoplay="3000" :show-indicators="false">
                    <van-swipe-item>
                        <div class="honor_swipe_items">
                            <img src="../assets/images/honor_1.png" alt="">
                            <img src="../assets/images/honor_2.png" alt="">
                            <img src="../assets/images/honor_3.png" alt="">
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="honor_swipe_items">
                            <img src="../assets/images/honor_4.png" alt="">
                            <img src="../assets/images/honor_5.png" alt="">
                            <img src="../assets/images/honor_6.png" alt="">
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="honor_swipe_items">
                            <img src="../assets/images/honor_7.png" alt="">
                            <img src="../assets/images/honor_8.png" alt="">
                            <img src="../assets/images/honor_9.png" alt="">
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="honor_swipe_items">
                            <img src="../assets/images/honor_10.png" alt="">
                            <img src="../assets/images/honor_11.png" alt="">
                            <img src="../assets/images/honor_12.png" alt="">
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="honor_swipe_items">
                            <img src="../assets/images/honor_13.png" alt="">
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <common-footer></common-footer>
    </div>
</template>

<script>
import commonHead from '../components/common-head.vue'
import commonFooter from '../components/common-footer.vue'
export default {
    data() {
        return {
        }
    },
    components: {
        commonHead,
        commonFooter
    },
}
</script>

<style lang="less" scoped>
.head_bg {
    background-image: url("../assets/images/banner_gsjs.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    & .head_content {
        position: relative;
        height: 155px;
        & img {
            width: 100px;
            height: 135px;
            position: absolute;
            left: 0px;
            bottom: 0;
        }

        & .head_content_text {
            color: #fff;
            animation: head_content_animation_0 2s;
            & > div:first-child {
                width: 22px;
                height: 49.5px;
                opacity: 0.64;
                font-family: Arial-BoldMT;
                font-size: 44px;
                color: #ffffff;
                position: absolute;
                top: 42px;
                left: 80px;
            }
            & .van-swipe {
                width: 248px;
                position: absolute;
                left: 110px;
                top: 58px;
                & .van-swipe-item > p {
                    width: 248px;
                    font-size: 12px;
                    color: #ffffff;
                    letter-spacing: 0;
                    line-height: 20px;
                    word-wrap: break-word;
                    word-break: break-all;
                    margin-bottom: 6px;
                }
            }
        }
    }
}

.introduce {
    padding: 36px 20px 46px;
    & p {
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        line-height: 20px;
    }
    & h1,
    & p:nth-child(2),
    & p:nth-child(3) {
        margin-bottom: 24px;
    }
    & p:nth-child(4) {
        margin-bottom: 29px;
    }
    & img {
        width: 335px;
        height: 160px;
    }
}
.honor {
    padding: 0px 20px 46px;
    & h1 {
        margin-bottom: 29.5px;
    }
    & .honor_swipe_items {
        display: flex;
        & img {
            width: 105px;
            height: 95px;
            display: block;
        }
        & > img:nth-child(1),
        & > img:nth-child(2) {
            margin-right: 10px;
        }
    }
}
@keyframes head_content_animation_0 {
    0% {
        opacity: 0;
        transform: translateY(-42px);
    }
    100% {
        opacity: 0.64;
        transform: translateY(0);
    }
}
</style>